import type { ReactNode } from "react";
import { CertificationModal } from "@modules/certificaciones/shared/ui";

type Props = {
  open: boolean;
  title: string;
  eyebrow?: string;
  submitting?: boolean;
  error?: string | null;
  children: ReactNode;
  footer: ReactNode;
  onClose: () => void;
  onSubmit: () => void;
  wide?: boolean;
};

export function Iso900114001Modal({
  open,
  title,
  eyebrow = "Edición",
  submitting = false,
  error = null,
  children,
  footer,
  onClose,
  onSubmit,
  wide = false,
}: Props) {
  return (
    <CertificationModal
      open={open}
      title={title}
      eyebrow={eyebrow}
      submitting={submitting}
      error={error}
      size={wide ? "wide" : "default"}
      footer={footer}
      onClose={onClose}
      onSubmit={onSubmit}
      closeOnBackdrop={false}
    >
      <div className="iso27001-filters-grid iso9001-form-grid">{children}</div>
    </CertificationModal>
  );
}
